import { useSelector } from 'react-redux';
import * as MessagingReportService from 'services/messaging/report';

export const useMessagingReportService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchReports = async (options = {}) => {
    const { error, payload } = await MessagingReportService.read({
      ...options,
      token
    });

    if (error) {
      return { logs: [] };
    }

    return { logs: payload.data };
  };

  const fetchComparativeReport = async (options = {}) => {
    return { data: {} };
  };

  const fetchPerformanceReport = async (options = {}) => {
    return { data: {} };
  };

  return {
    fetchReports,
    fetchComparativeReport,
    fetchPerformanceReport
  };
};
